import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'

export default function Protected({ children, pexList = [] }) {
	const loggedIn = useSelector((state) => state.user.value.loggedIn)
	const pex = useSelector((state) => state.user.value.pex)
	const location = useLocation()
	if (!loggedIn) {
		const url = '/login?futureAdresse=' + encodeURIComponent(location.pathname)
		return <Navigate to={url} replace />
	}
	let access = true
	for (const pexValue of pexList) {
		if (!pex[pexValue]) {
			access = false
			break
		}
	}
	if (!access) {
		return <Navigate to='/' replace />
	}
	return children
}
